// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"6d96d736","247":"7f9d64db","314":"2b5df6ae","513":"030ceaf8","706":"cc727622"}[chunkId] + ".chunk.js";
};